import React from "react";

import { Table } from "semantic-ui-react";
import StockRow from "../StockRow/StockRow";
import "./StockTable.css";

const StockTable = ({
  shelves,
  missingAmount,
  confirmCallback,
  currentTotal,
  setCurrentTotal,
  forceLiftShelfCallback,
  cancelLiftShelfCallback,
  forcedLiftShelves,
}) => {
  const hasLiftShelves = shelves.some((s) => s.isLiftShelf);
  const hasChannels = shelves.some((shelf) => shelf.channels.length != 0)
  
  return (
    <Table className={"MissingStockShelf"} compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign="left" width={3}>
            Hylla
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="left" width={3} className={hasChannels ? "" : "hidden"}>
            Kanal
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="left" width={3}>
            Saldo
          </Table.HeaderCell>
          <Table.HeaderCell width={2} className={missingAmount > 1 ? "" : "hidden"}>
            Hittat antal
          </Table.HeaderCell>
          <Table.HeaderCell
            width={2}
            className={missingAmount === 1 || hasLiftShelves ? "" : "hidden"}
          ></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {shelves.map((shelf) => (
          <StockRow
            key={shelf.shelfNumber}
            shelf={shelf}
            missingAmount={missingAmount}
            confirmCallback={confirmCallback}
            currentTotal={currentTotal}
            inputCallBack={setCurrentTotal}
            forceLiftShelfCallback={forceLiftShelfCallback}
            cancelLiftShelfCallback={cancelLiftShelfCallback}
            liftShelfForced={forcedLiftShelves.includes(shelf.shelfNumber)}
            channels={shelf.channels}
            hasChannels={hasChannels} 
          />
        ))}
      </Table.Body>
    </Table>
  );
};

export default StockTable;
